import { Box, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { GridRowModel } from "@mui/x-data-grid-pro";

import { ErrorMessageFormDetails } from "../interfaces";
import { isObject } from "../../services/utils";
import { FieldInputProps } from "formik";

const ErrorMessage = ({
  fieldsOptions,
  field,
  row,
}: {
  fieldsOptions: ErrorMessageFormDetails;
  field: FieldInputProps<any>;
  row: GridRowModel;
}) => {
  return (
    <Box>
      <Typography component={"span"} sx={{ color: "error.main" }}>
        {!isObject(field.value) && (
          <FormattedMessage id={fieldsOptions.label} />
        )}
        {isObject(field.value) && !!field.value.errorMessageValue && (
          <FormattedMessage
            id={fieldsOptions.label}
            values={{
              value: Math.floor(
                field.value.errorMessageValue
              ) as unknown as string,
            }}
          />
        )}
      </Typography>
    </Box>
  );
};

export default ErrorMessage;
